module.exports = __webpack_public_path__ + "img/wine rack.ae6aa57f.png";